document.documentElement.classList.remove("no-js");

const header = document.querySelector("[data-site-header]");
const menuToggle = document.querySelector("[data-menu-toggle]");
const mobileNavigation = window.matchMedia("(max-width: 900px)");

const closeNavigation = ({ returnFocus = false } = {}) => {
  document.querySelectorAll("[data-nav-item]").forEach((item) => {
    item.dataset.open = "false";
    item.querySelector("[data-submenu-toggle]")?.setAttribute("aria-expanded", "false");
  });

  if (header && menuToggle) {
    header.dataset.menuOpen = "false";
    menuToggle.setAttribute("aria-expanded", "false");
    if (returnFocus) menuToggle.focus();
  }
};

if (header && menuToggle) {
  menuToggle.addEventListener("click", () => {
    const open = header.dataset.menuOpen !== "true";
    header.dataset.menuOpen = String(open);
    menuToggle.setAttribute("aria-expanded", String(open));

    if (open) {
      requestAnimationFrame(() => {
        document.querySelector("#PrimaryNavigation a, #PrimaryNavigation button")?.focus();
      });
    } else {
      menuToggle.focus();
    }
  });
}

const handleNavigationBreakpoint = (event) => {
  if (!event.matches) closeNavigation();
};
if (typeof mobileNavigation.addEventListener === "function") {
  mobileNavigation.addEventListener("change", handleNavigationBreakpoint);
} else {
  mobileNavigation.addListener(handleNavigationBreakpoint);
}

document.querySelectorAll("[data-submenu-toggle]").forEach((toggle) => {
  toggle.addEventListener("click", () => {
    const item = toggle.closest("[data-nav-item]");
    const open = item?.dataset.open !== "true";
    document.querySelectorAll("[data-nav-item]").forEach((navItem) => {
      navItem.dataset.open = "false";
      navItem.querySelector("[data-submenu-toggle]")?.setAttribute("aria-expanded", "false");
    });
    if (item) item.dataset.open = String(open);
    toggle.setAttribute("aria-expanded", String(open));
  });
});

document.addEventListener("click", (event) => {
  if (!header || header.contains(event.target)) return;
  closeNavigation();
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;
  const activeSubmenuToggle = document.activeElement?.closest?.("[data-nav-item]")?.querySelector?.("[data-submenu-toggle]");
  const mobileMenuWasOpen = Boolean(header?.dataset.menuOpen === "true");
  closeNavigation({ returnFocus: mobileMenuWasOpen });
  if (!mobileMenuWasOpen && activeSubmenuToggle instanceof HTMLElement) activeSubmenuToggle.focus();
});

document.querySelectorAll("#PrimaryNavigation a").forEach((link) => {
  link.addEventListener("click", () => {
    if (mobileNavigation.matches) closeNavigation();
  });
});

const formMessage = document.querySelector('.um-form-message[tabindex="-1"], .smart-form__message[tabindex="-1"]');
if (formMessage) {
  requestAnimationFrame(() => formMessage.focus());
}

const contactForms = document.querySelectorAll('form[action^="/contact"]');
contactForms.forEach((form) => {
  const syncValidity = (event) => {
    const control = event.target;
    if (!(control instanceof HTMLInputElement || control instanceof HTMLSelectElement || control instanceof HTMLTextAreaElement)) return;
    if (control.checkValidity()) control.removeAttribute("aria-invalid");
  };

  form.addEventListener("invalid", (event) => {
    const control = event.target;
    if (control instanceof HTMLInputElement || control instanceof HTMLSelectElement || control instanceof HTMLTextAreaElement) {
      control.setAttribute("aria-invalid", "true");
    }
  }, true);
  form.addEventListener("input", syncValidity);
  form.addEventListener("change", syncValidity);

  if (form.classList.contains("smart-form")) return;
  form.addEventListener("submit", (event) => {
    if (form.dataset.submitting === "true") {
      event.preventDefault();
      return;
    }

    const button = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!(button instanceof HTMLButtonElement || button instanceof HTMLInputElement)) return;
    form.dataset.submitting = "true";
    button.disabled = true;
    button.setAttribute("aria-busy", "true");

    setTimeout(() => {
      if (!form.isConnected) return;
      form.dataset.submitting = "false";
      button.disabled = false;
      button.removeAttribute("aria-busy");
    }, 20000);
  });
});

const query = new URLSearchParams(window.location.search);
if ([...query.keys()].some((key) => key.startsWith("filter.") || key === "sort_by")) {
  let robots = document.querySelector('meta[name="robots"]');
  if (!robots) {
    robots = document.createElement("meta");
    robots.name = "robots";
    document.head.append(robots);
  }
  robots.content = "noindex,follow";
}

const analyticsContracts = Object.freeze({
  rfq_step_view: Object.freeze({
    step: Object.freeze(["1", "2", "3", "4", "5"])
  }),
  rfq_submitted: Object.freeze({
    machine_family: Object.freeze([
      "FIBER_LASER",
      "TUBE_LASER",
      "PRESS_BRAKE",
      "LASER_WELDING",
      "LASER_CLEANING",
      "UNSURE"
    ]),
    request_type: Object.freeze([
      "NEW_EQUIPMENT",
      "REPLACEMENT",
      "PROCESS_REVIEW",
      "SERVICE_CONTEXT"
    ]),
    outcome: Object.freeze(["ACCEPTED"])
  })
});

window.umprotechTrack = (eventName, controlledFields = {}) => {
  if (document.body.dataset.analyticsEnabled !== "true") return;
  const contract = analyticsContracts[eventName];
  if (!contract || !controlledFields || typeof controlledFields !== "object") return;
  const payload = {};
  for (const [field, allowedValues] of Object.entries(contract)) {
    const value = controlledFields[field];
    if (typeof value !== "string" || !allowedValues.includes(value)) return;
    payload[field] = value;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...payload });
};
